import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-dialog-search',
    templateUrl: './dialog-search.component.html',
    styleUrl: './dialog-search.component.css',
    imports: [ReactiveFormsModule],
})
export class DialogSearchComponent {
    readonly placeholder = input('');
    readonly testId = input.required<string>();
    readonly searchChange = output<string>();

    readonly searchControl = new FormControl('', { nonNullable: true });

    onSearch(): void {
        this.searchChange.emit(this.searchControl.value.trim());
    }

    onClear(): void {
        this.searchControl.setValue('');
        this.searchChange.emit('');
    }
}
